import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Public strip of verified brands pulled from Airtable
 * (rows where the `Show On Site` checkbox is TRUE).
 * Renders nothing when there are no featured brands — safe default.
 */
export default function FeaturedBrandsStrip() {
  const [brands, setBrands] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/brand/featured`)
      .then((r) => setBrands(r.data?.brands || []))
      .catch(() => setBrands([]))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || brands.length === 0) return null;

  return (
    <div
      data-testid="featured-brands-strip"
      className="mb-8 border border-line bg-white"
    >
      <div className="flex items-center justify-between px-5 py-3 border-b border-line">
        <span className="font-sans font-semibold text-[11px] uppercase tracking-[0.24em] text-brand-orange">
          Now on SheScan
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-soft">
          {brands.length} verified{brands.length === 1 ? " brand" : " brands"}
        </span>
      </div>
      <ul className="divide-y divide-line">
        {brands.map((b, i) => {
          const href = b.website
            ? b.website.startsWith("http")
              ? b.website
              : `https://${b.website}`
            : null;
          return (
            <li
              key={`${b.brand_name}-${i}`}
              data-testid={`featured-brand-${i}`}
              className="flex items-center justify-between gap-4 px-5 py-3 hover:bg-paper-soft transition-colors"
            >
              <div className="min-w-0 flex-1">
                <div className="font-sans font-semibold text-sm text-ink truncate">
                  {b.brand_name}
                </div>
                {b.category && (
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-soft mt-0.5">
                    {b.category}
                  </div>
                )}
              </div>
              {href && (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`featured-brand-link-${i}`}
                  className="inline-flex items-center gap-1.5 font-sans font-semibold text-xs uppercase tracking-[0.18em] text-ink hover:text-brand-orange transition-colors whitespace-nowrap"
                >
                  Visit
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
